import { render, staticRenderFns } from "./pageDataCard.vue?vue&type=template&id=6da13aee&scoped=true"
import script from "./pageDataCard.vue?vue&type=script&lang=js"
export * from "./pageDataCard.vue?vue&type=script&lang=js"
import style0 from "./pageDataCard.vue?vue&type=style&index=0&id=6da13aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da13aee",
  null
  
)

export default component.exports